import { PostTypeReel } from '~publish/legacy/post/constants'

import type { DraftMediaCounts } from './getMediaMixConflict'

export type PostTypeAssetLimitConflict = 'reelTooManyAssets'

const INSTAGRAM_REEL_MAX_ASSETS = 1

/**
 * Flags a draft whose selected post type can't hold its attached asset
 * count — e.g. an Instagram Reel, which the backend caps at one asset
 * regardless of mixed-media capability. Unlike `getMediaMixConflict`, this
 * cap doesn't lift with a Split flag: it's a hard limit of the post type
 * itself.
 * @see domains/updates-domain/src/use-cases/create/validators/services/instagram/rules.ts
 */
export function getPostTypeAssetLimitConflict(
  serviceName: string,
  updateType: string | null | undefined,
  media: DraftMediaCounts,
): PostTypeAssetLimitConflict | null {
  const totalAssets = media.imageLikeCount + media.videoCount

  if (
    serviceName === 'instagram' &&
    updateType === PostTypeReel &&
    totalAssets > INSTAGRAM_REEL_MAX_ASSETS
  ) {
    return 'reelTooManyAssets'
  }

  return null
}
